export class FirmFirmTransformer {
  static transform(obj) {
    let firmFirm = {};

    firmFirm.id = obj.id;
    firmFirm.parent_id = obj.attributes.parent_id;
    firmFirm.child_id = obj.attributes.child_id;
    firmFirm.code = obj.attributes.code;
    firmFirm.archived_at = obj.attributes.archived_at;
    firmFirm.deleted_at = obj.attributes.deleted_at;
    firmFirm.contract_code = obj.attributes.contract_code;
    // firmFirm.name = obj.attributes.name;

    return firmFirm;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/firmFirms/firmFirm.transformer.js